import { Injectable, inject } from "@angular/core";
import { SwUpdate, VersionEvent } from "@angular/service-worker";
import { MatSnackBar } from "@angular/material/snack-bar";
import { filter } from "rxjs/operators";

@Injectable({
  providedIn: "root"
})
export class UpdateService {
  private swUpdate = inject(SwUpdate);
  private snackbar = inject(MatSnackBar);

  constructor() {
    this.swUpdate.versionUpdates
      .pipe(filter((evt): evt is VersionEvent => evt.type === "VERSION_READY"))
      .subscribe((evt) => {
        console.log("updating", evt);
        const snack = this.snackbar.open(
          "A new update is available. Refresh the page or press Reload to install.",
          "Reload"
        );

        snack.onAction().subscribe(() => {
          this.swUpdate.activateUpdate().then(() => {
            window.location.reload();
          });
        });
      });
  }

  get isEnabled() {
    return this.swUpdate.isEnabled;
  }

  checkForUpdates() {
    if (this.swUpdate.isEnabled) {
      this.swUpdate
        .checkForUpdate()
        .then(() => {
          // Handle check complete
        })
        .catch((err) => {
          console.error("Failed to check for updates:", err);
        });
    }
  }
}
